import React, { PropsWithChildren } from 'react';

type FormsComboboxMultiselectSelectionType = PropsWithChildren<{
  id: string;
  title: string;
}>;

export function FormsComboboxMultiselectSelection({ id, title, children }: FormsComboboxMultiselectSelectionType) {
  return (
    <div className="forms-combobox-multiselect__selection">
      <p className="forms-combobox-multiselect__title" id={id}>
        {title}
      </p>
      <div className="forms-combobox-multiselect__interactions">{children}</div>
    </div>
  );
}
